import localeService from 'client/i18n/locale-service';

const initalizeLocaleService = async () => {
  localeService.setLocale(localeService.getLocale());
};

export default initalizeLocaleService;
